import { render, staticRenderFns } from "./ListKarantina.vue?vue&type=template&id=6cb4ca67&scoped=true&"
import script from "./ListKarantina.vue?vue&type=script&lang=js&"
export * from "./ListKarantina.vue?vue&type=script&lang=js&"
import style1 from "./ListKarantina.vue?vue&type=style&index=1&id=6cb4ca67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb4ca67",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QCard,QCardSection,QInput,QBtn,QMarkupTable,QPagination,QTable});
